export const ASSET_ONBOARDING_V1 = "Asset Onboarding V1";
export const ASSET_ONBOARDING_V1_STEPS = {
  ENTRY: "Entry",
  ITEM_ONBOARD_SUCCESS: "Item Onboard Success",
  ITEM_ONBOARD_FAILED: "Item Onboard Failed"
};
